'use strict';

angular.module('rmEPG')
    .directive('epgScheduleDay', ['$http', '$state', '$timeout', '$rootScope',
        function ($http, $state, $timeout, $rootScope) {

            let broadcastBefore;
            let $document = $(document);

            let minutesInADay = 1440; // 24x60
            let hourHeight = 70; // 70px .TimeTime box height
            let minuteHeight = hourHeight / 60;
            let minuteHeightDivided = minuteHeight / 100;

            function getMinutes(time) {
                return (time.hour() * 60) + time.minute();
            }

            function updateBroadcasts(broadcasts, zoomFactor) {

                /*
                let collidesWith = {};
                let offsets = {};
                let maxOffset = 0;
                */
                let rows = [
                    []
                ];

                broadcasts.forEach((broadcast, i) => {

                    // Calculate zoom heights
                    let minuteHeightWithZoom = (minuteHeightDivided) * zoomFactor;
                    broadcast._start = moment.tz(broadcast.start, window.CONFIG.timezone);
                    broadcast._stop = moment.tz(broadcast.stop, window.CONFIG.timezone);

                    let startMinute = getMinutes(broadcast._start);
                    let stopMinute = getMinutes(broadcast._stop);
                    stopMinute = stopMinute === 0 ? minutesInADay : stopMinute;
                    broadcast._y = Math.round(startMinute * minuteHeightWithZoom);
                    broadcast._h = Math.round((stopMinute - startMinute) * minuteHeightWithZoom);
                    // reset collision
                    broadcast._collide = false;

                    broadcasts.forEach((b) => {
                        broadcasts.forEach((k) => {
                            if (b == k) return;
                            if (collides(b, k)) {
                                subBroadcastCheck(b, k);
                                b._collide = true;
                            }
                        });
                    });

                    // Loop untill we find a row which doesnt have broadcasts colliding
                    let nextRow = true;
                    while (nextRow) {
                        for (let i = 0, l = rows.length + 1; i < l; i++) {
                            let goNext = false;
                            let row = rows[i];
                            for (let i = 0, l = row.length; i < l; i++) {
                                let value = row[i];
                                if (collides(broadcast, value)) {
                                    goNext = true;
                                    break;
                                }
                            }
                            if (goNext) {
                                // If its the last row and a new one
                                if (i + 1 === rows.length) {
                                    rows.push([]);
                                }
                                continue;
                            }
                            nextRow = false;
                            row.push(broadcast);
                            break;
                        }
                    }
                });

                let w = 100 / rows.length;
                rows.forEach((row, i) => {
                    let offset = i * w;
                    row.forEach((broadcast) => {

                        if (broadcast.subBroadcast) {
                            broadcast._x = '10%';
                            broadcast._w = '90%';
                        }
                        else if (broadcast.subBroadcastParent) {
                            broadcast._x = '0%';
                            broadcast._w = '90%'
                        } else {
                            broadcast._x = offset + '%';
                            broadcast._w = w + '%';
                        }
                    });
                });

                if (rows.length > 1) {
                    rows[0].forEach((broadcast) => {
                        if (!broadcast._collide) {
                            broadcast._x = '0%';
                            broadcast._w = '100%';
                        }
                    });
                }
            }

            function round(target, num) {
                return Math.round(target / num) * num;
            }

            function ceil(target, num) {
                return Math.ceil(target / num) * num;
            }

            function pixelToMinutes(pixel, height) {
                return Math.round((minutesInADay / height) * pixel);
            }

            function subBroadcastCheck(value, item) {

                if (value.model_type) {
                    if (value.model_type.options.subBroadcast) {
                        value.subBroadcast = true;
                    }
                }
                if (item.model_type) {
                    if (item.model_type.options.subBroadcast) {
                        value.subBroadcastParent = true;
                    }
                }

                return ((value.start == item.start && value.subBroadcast) || // Same start
                    (value.stop == item.stop && value.subBroadcast) || // Same end
                    (value._start > item._start && value._start < item._stop && value.subBroadcast) || // Value start inbetween item
                    (value._stop > item._start && value._stop < item._stop && value.subBroadcast) || // Value stop inbetween item
                    (item._start > value._start && item._start < value._stop && value.subBroadcast) || // Item start inbetween value
                    (item._stop > value._start && item._stop < value._stop && value.subBroadcast) // Item stop inbetween value
                );
            }

            function minutesToPixels(minutes, height) {
                return Math.round((height / minutesInADay) * minutes);
            }

            function collides(value, item) {
                return ((value.start == item.start) || // Same start
                    (value.stop == item.stop) || // Same end
                    (value._start > item._start && value._start < item._stop) || // Value start inbetween item
                    (value._stop > item._start && value._stop < item._stop) || // Value stop inbetween item
                    (item._start > value._start && item._start < value._stop) || // Item start inbetween value
                    (item._stop > value._start && item._stop < value._stop) // Item stop inbetween value
                );
            }

            return {
                restrict: 'E',
                scope: {
                    refresh: '=epgRefreshTrigger',
                    zoom: '=epgZoom',
                    date: '=epgDate',
                    data: '=epgData',
                    masterStations: '=epgMasterData',
                    resizeEvent: '&epgOnBroadcastResize'
                },
                templateUrl: '/partial/app.partials.epg.schedule_day',
                link: function (scope, element, attrs) {
                    let innerHeight;
                    let $holder = element.find('.epg-broadcasts');
                    let PLANNING = null;
                    let PLANNING_START = 0;
                    let PLANNING_START_TIME = 0;
                    let RESIZE = null;
                    let RESIZE_START = false;
                    let RESIZE_STOP = false;
                    let SNAP = 10;

                    // Init
                    $timeout(() => {
                        innerHeight = $holder.height();
                        updateBroadcasts(scope.data.broadcasts, scope.zoom);

                        element.on('mousedown touchstart', mouseDown);
                        element.on('click', onClick);

                        element.find('.TimeTime').css({
                            height: ((70 / 100) * scope.zoom) + 'px'
                        });
                    });


                    // Watchers
                    scope.$watch('zoom', () => {
                        if (scope.zoom > 150) {
                            SNAP = 5;
                        } else {
                            SNAP = 15;
                        }
                        updateBroadcasts(scope.data.broadcasts, scope.zoom);
                    });

                    // refresh trigger
                    scope.$watch('refresh', () => {
                        updateBroadcasts(scope.data.broadcasts, scope.zoom);
                    });

                    scope.$on('$destroy', () => {
                        element.off('mousedown touchstart', mouseDown);
                        element.off('click', onClick);

                        $document.off('mouseup touchend', endPlanning);
                        $document.off('mousemove touchmove', trackPlanning);
                        $document.off('keyup', onKey);
                    });

                    // Functions who need the closure
                    function onKey(event) {
                        if (event.which === 27) {
                            PLANNING = null;
                            $('.epg-dragging').remove();
                            $document.off('mouseup touchend', endPlanning);
                            $document.off('mousemove touchmove', trackPlanning);
                            $document.off('keyup', onKey);
                        }
                    }

                    function onClick(e) {
                        if (RESIZE || PLANNING) {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        } else if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
                            let target = $(e.target).closest('.epg-broadcast');
                            if (target.find(e.target) && target.data('broadcastId')) {
                                $state.go('epg.update', {
                                    broadcastId: target.data('broadcastId'),
                                    date: scope.date
                                });
                            }
                        }
                    }

                    function mouseDown(event) {
                        let permissionCheck = (($(event.currentTarget).attr('management-permission')) == 'true');
                        if (event.originalEvent.button !== 0 || event.ctrlKey || event.shiftKey || event.metaKey || !permissionCheck) {
                            return;
                        }
                        let target = $(event.target);
                        if (target.hasClass('TimeTime')) {
                            startPlanning(event, target);
                        } else if (target.hasClass('bottom-dragger')) {
                            startResize(event, target, true);
                            return false;
                        } else if (target.hasClass('top-dragger')) {
                            startResize(event, target, false);
                            return false;
                        }
                    }


                    function guid_s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    function guid() {
                        return guid_s4() + guid_s4() + '-' + guid_s4() + '-' + guid_s4() + '-' + guid_s4() + '-' + guid_s4() + guid_s4() + guid_s4();
                    }

                    function startPlanning(event, target) {
                        let innerHeight = $holder.height();
                        let time = pixelToMinutes(target.position().top + event.offsetY, innerHeight);
                        let y = minutesToPixels(round(time, SNAP), innerHeight);

                        PLANNING_START = y;
                        let uid = guid();
                        $rootScope.$broadcast('epg_current_uid', uid);
                        PLANNING = $('<md-card class="epg-dragging epg-broadcast" data-uid="' + uid + '" style="background: #54bed3;"><time class="md-caption"></time></md-card>')
                            .css({
                                top: y + 'px',
                                width: '100%',
                                height: 5 + 'px',
                            })
                            .appendTo($holder);

                        let start = round(pixelToMinutes(y, innerHeight), SNAP);
                        PLANNING_START_TIME = moment().hours(0).minutes(start).format('HH:mm');

                        $document.on('mouseup touchend', endPlanning);
                        $document.on('mousemove touchmove', trackPlanning);
                        $document.on('keyup', onKey);
                        return;
                    }

                    function endPlanning(event) {
                        if (PLANNING) {
                            let top = PLANNING.position().top;
                            let height = PLANNING.innerHeight();
                            if (height === 3) return cleanupPlanning();

                            let start = pixelToMinutes(top, $holder.height());
                            let stop = pixelToMinutes(top + height, $holder.height());
                            if (start !== stop) {
                                start = round(start, SNAP);
                                stop = round(stop, SNAP);

                                let timezoneFix = moment(scope.date).tz(window.CONFIG.timezone).format('Z');
                                $state.go('epg.create', {
                                    start: scope.date + 'T' + moment().hours(0).minutes(start).format('HH:mm') + ':00' + timezoneFix,
                                    end: scope.date + 'T' + moment().hours(0).minutes(stop).format('HH:mm') + ':00' + timezoneFix,
                                    date: scope.date
                                });
                            }
                        }
                        cleanupPlanning();
                    }

                    function cleanupPlanning() {
                        //$('.epg-dragging').remove();
                        $document.off('mouseup touchend', endPlanning);
                        $document.off('mousemove touchmove', trackPlanning);
                        $document.off('keyup', onKey);
                        setTimeout(() => {
                            PLANNING = null;
                        });
                    }

                    function trackPlanning(event) {
                        let target = $(event.target);
                        let innerHeight = $holder.height();
                        let time = pixelToMinutes(target.position().top + event.offsetY, innerHeight);
                        let offsetTop = minutesToPixels(round(time, SNAP), innerHeight);

                        PLANNING.css({
                            height: Math.max(3, offsetTop - PLANNING_START) + 'px'
                        });

                        let stop = round(time, SNAP);
                        stop = moment().hours(0).minutes(stop).format('HH:mm');
                        PLANNING.find('time').html(PLANNING_START_TIME + ' - ' + stop);
                    }

                    function startResize(event, target, height) {
                        event.preventDefault();
                        RESIZE = target.closest('.epg-broadcast');
                        let y = RESIZE.position().top;
                        if (height) {
                            RESIZE_START = y;
                        } else {
                            RESIZE_STOP = y + RESIZE.innerHeight() + 2;
                        }
                        $document.on('mousemove touchmove', trackResize);
                        $document.on('mouseup touchend', endResize);
                        $document.on('keyup', resizeOnKeyUp)
                    }

                    function trackResize(event) {
                        let target = $(event.target);
                        if (!target.hasClass('TimeTime')) {
                            if (target.hasClass('bottom-dragger')) {
                                event.offsetY += target.position().top;
                            }
                            target = target.closest('.epg-broadcast');
                        }
                        let pos = target.position();
                        if (!pos) {
                            return;
                        }
                        let innerHeight = $holder.height();
                        let time = pixelToMinutes(pos.top + event.offsetY, innerHeight);
                        let y = minutesToPixels(round(time, SNAP), innerHeight);
                        let start, stop;
                        if (!RESIZE_STOP) {
                            RESIZE.css({
                                height: Math.max(5, y - RESIZE_START) + 'px'
                            });
                            start = RESIZE.find('time').html().split('-')[0];
                            stop = (RESIZE_STOP !== false) ? pixelToMinutes(RESIZE_STOP, innerHeight) : round(time, SNAP);
                            stop = moment().hours(0).minutes(stop).format('HH:mm');
                        } else {
                            RESIZE.css({
                                top: y + 'px',
                                height: Math.max(5, RESIZE_STOP - y) + 'px'
                            });
                            stop = RESIZE.find('time').html().split('-')[1];
                            start = (RESIZE_START !== false) ? pixelToMinutes(RESIZE_START, innerHeight) : round(time, SNAP);
                            start = moment().hours(0).minutes(start).format('HH:mm');
                        }
                        RESIZE.find('time').html(start + ' - ' + stop);
                    }

                    function resetResize(broadcast) {
                        RESIZE.css({
                            left: broadcast._x || 0,
                            top: broadcast._y,
                            height: broadcast._h - 2,
                            width: broadcast._w || '100%',
                        });
                    }

                    function getBroadcastById(id) {
                        let foundBroadcastsArray = scope.data.broadcasts.filter(broadcast => broadcast.id === id);
                        return foundBroadcastsArray[0] || null;
                    }

                    function resizeOnKeyUp(event) {
                        if (event.which === 27) {
                            let id = RESIZE.data('broadcastId');
                            resetResize(getBroadcastById(id));

                            $document.off('mousemove touchmove', trackResize);
                            $document.off('mouseup touchend', endResize);
                            $document.off('keyup', resizeOnKeyUp);
                            RESIZE_START = false;
                            RESIZE_STOP = false;

                            // Timeout to cancel the click;
                            setTimeout(() => {
                                RESIZE = null;
                            }, 100);
                        }
                    }

                    function endResize(event) {
                        let offsetTop = (RESIZE_START) ? RESIZE_START : RESIZE.position().top;
                        let start = pixelToMinutes(offsetTop, $holder.height());
                        let stop = pixelToMinutes(offsetTop + RESIZE.innerHeight(), $holder.height());
                        start = round(start, SNAP);
                        stop = round(stop, SNAP);
                        let id = RESIZE.data('broadcastId');

                        let cb = status => {
                            if (status === false) {
                                resetResize(getBroadcastById(id));
                            }
                            // Timeout to cancel the click;
                            setTimeout(() => {
                                RESIZE = null;
                            }, 100);
                        };

                        if (RESIZE_STOP) {
                            scope.resizeEvent({
                                broadcastId: id,
                                start: scope.date + 'T' + moment().hours(0).minutes(start).format('HH:mm') + ':00',
                                stop: false,
                                cb: cb,
                            });
                        } else {
                            scope.resizeEvent({
                                broadcastId: id,
                                start: false,
                                stop: scope.date + 'T' + moment().hours(0).minutes(stop).format('HH:mm') + ':00',
                                cb: cb,
                            });
                        }

                        $document.off('mousemove touchmove', trackResize);
                        $document.off('mouseup touchend', endResize);
                        $document.off('keyup', resizeOnKeyUp);
                        RESIZE_START = false;
                        RESIZE_STOP = false;
                    }
                }
            };
        }
    ]);

